<template>
  <div>
    <v-layout row wrap justify-end>
      <v-btn :loading="exportloading" color="grey" outline @click="exportxlsx">
        <em class="fas fa-file-export" />
        &nbsp;Export&nbsp;
      </v-btn>
    </v-layout>
    <div class="mb-2">
      <date-filter
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="onChangeDate"
      ></date-filter>
    </div>
    <v-layout row wrap>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <input v-model="filter.search" class="form-control" placeholder="ค้นหา" type="text" />
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <v-btn color="primary" @click="handleSearch">ค้นหา</v-btn>
        </div>
      </v-flex>
    </v-layout>

    <template v-if="selectCampaign && selectCampaign.type == 'lucky_draw'">
      <multiselect
        v-model="receiptStatus"
        :options="['ทั้งหมด', 'รอลูกค้ากรอกข้อมูลกลับ', 'กรอกข้อมูลเรียบร้อยแล้ว', 'อนุมัติแล้ว']"
        :searchable="false"
        select-label
        selected-label
        deselect-label
        :multiple="false"
        :placeholder="'ดูตามสถานะการกรอกข้อมูล'"
        style="max-width: 300px"
        @select="onSelectReceiptStatus"
      ></multiselect>
    </template>
    <v-layout row wrap align-content-end justify-end>
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </v-layout>
    <v-layout row wrap>
      <v-checkbox
        label="เลือกทั้งหมด"
        class="col-auto"
        style="width: max-content"
        color="primary"
        @change="onApproveAllInCurrentPage($event)"
      ></v-checkbox>
      <v-btn color="primary" :loading="approveLoading" @click="onApprove">Approve</v-btn>
      <v-btn color="primary" outline :loading="approveAllLoading" @click="onApproveAll"
        >Approve all</v-btn
      >
    </v-layout>
    <div v-if="loading" class="text-xs-center mt-4 mb-5">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-for="(item, index) in items" v-else :key="index" class="card-outline mb-5">
      <v-layout class="px-3 mb-0" row wrap justify-space-between>
        <v-flex shrink>
          <v-checkbox
            :input-value="IsCheckAllOrder"
            :label="`Order No. ${item.id}`"
            class="col-auto"
            style="width: max-content"
            color="primary"
            @change="chooseOrder(item, $event)"
          ></v-checkbox>
        </v-flex>
        <v-flex shrink class="pl-3">
          <v-chip
            v-if="!item.identity_image"
            color="warning"
            small
            class="white--text mt-3"
            disabled
          >
            รอลูกค้ากรอกข้อมูลกลับ
          </v-chip>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn
            flat
            @click="
              selectedReward = item
              showHistory = true
            "
          >
            {{ item.adminid || 'ประวัติการอนุมัติ' }}
          </v-btn>
        </v-flex>
        <!-- <span style="margin-top: 20px">Assignee : -</span> -->
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap class="mt-1">
        <v-flex xs7 sm8>
          <div class="pt-2" style="border-right: 1px solid #eee">
            <!-- <v-layout row justify-end class="text-gray"> {{ item.total_points }} </v-layout> -->
            <div class="pl-3">
              <v-layout v-for="p in item.productdetails" :key="p.id" row wrap>
                <v-flex xs4>
                  <v-img :src="p.photo"></v-img>
                </v-flex>
                <v-flex xs8 class="mt-2 pl-3">
                  <div>{{ p.name }}</div>
                  <template v-if="selectCampaign && selectCampaign.type != 'lucky_draw'">
                    <div class="text-cus">ใช้ {{ p.points / p.quantity }} แต้ม</div>
                    <div class="text-cus">จำนวนที่แลกทั้งหมด {{ p.quantity }} สิทธิ์</div>
                    <div class="text-cus">รวม {{ p.points }} แต้ม</div>
                  </template>
                </v-flex>
              </v-layout>
              <template v-if="selectCampaign && selectCampaign.type != 'lucky_draw'">
                <div class="mt-2">แต้มทั้งหมด {{ item.original_score || '-' }} แต้ม</div>
                <div class="mt-2">แต้มที่ใช้ทั้งหมด {{ item.total_points }} แต้ม</div>
                <div class="mt-2">
                  แต้มคงเหลือ
                  {{ item.original_score ? item.original_score - item.total_points : '-' }} แต้ม
                </div>
              </template>
            </div>
            <v-btn
              outline
              small
              color="primary"
              :disabled="!item.identity_image"
              @click="
                currentIdentity = item.identity_image
                showIdentity = true
              "
            >
              ภาพบัตรประชาชน
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs5 sm4>
          <div style="word-break: break-word" class="pa-2">
            <h6 v-if="PAGE.TOA_MEGA_PAINT.includes(selectedBot.pageid)">
              {{ item.registration_data.first_name + ' ' + item.registration_data.last_name }} ({{
                item.linename
              }})
            </h6>
            <h6 v-else>
              {{ item.registration_data.firstName + ' ' + item.registration_data.lastName }} ({{
                item.linename
              }})
            </h6>
            <div class="mt-2">{{ item.first_name + ' ' + item.last_name }}</div>
            <div class="mt-2 text-gray">
              {{
                (item.address || '') +
                ' ' +
                (item.sub_district || '') +
                ' ' +
                (item.district || '') +
                ' ' +
                (item.province || '') +
                ' ' +
                (item.post_code || '') +
                (item.phone_number ? ' , เบอร์โทรศัพท์ ' + item.phone_number : '')
              }}
            </div>
            <div class="my-4">
              <div>สถานะ</div>
              <div class="primary--text">{{ item.shippoing_status || 'รอดำเนินการ' }}</div>
              <template v-if="PAGE.TOA_MEGA_PAINT.includes(selectedBot.pageid)">
                <div class="mt-3">วันที่แลกของรางวัล</div>
                <div class="primary--text">
                  {{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
                </div>
              </template>
              <div class="mt-3">ป้ายกำกับ</div>
              <div class="primary--text">-</div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="showIdentity" scrollable max-width="500px">
      <v-card>
        <div class="text-xs-right">
          <v-btn
            small
            flat
            fab
            @click="
              currentIdentity = null
              showIdentity = false
            "
          >
            <v-icon> close </v-icon>
          </v-btn>
        </div>
        <v-card-text v-if="currentIdentity">
          <img style="width: 100%" :src="currentIdentity" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHistory">
      <v-card>
        <v-card-title>
          <span class="title primary--text"> ประวัติการอนุมัติ </span>
          <v-spacer />
          <v-btn
            icon
            @click="
              showHistory = false
              selectedReward = null
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <table class="zw-table fullwidth">
            <thead>
              <tr>
                <th>ชื่อ Admin</th>
                <th>ทำรายการเมื่อ</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="selectedReward && selectedReward.approve_history.length > 0">
                <template v-for="(history, index) in selectedReward.approve_history">
                  <tr :key="index">
                    <td>{{ history.adminid }}</td>
                    <td>{{ history.timestamp }}</td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td colspan="2" class="text-xs-center">No data</td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import MemberEdit from './MemberEdit.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import SearchMember from './SearchMember.vue'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import MemberHistoryCoupon from './MemberHistoryCoupon.vue'
import * as XLSX from 'xlsx'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    Multiselect,
    SearchMember,
    DatePickerWithoutButton,
    MemberEdit,
    exportxlsx,
    DateFilter,
    MemberHistoryCoupon
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    selectCampaign() {
      return this.$store.state.selectToaCampaign
    },
    PAGE() {
      return PAGE
    }
  },
  data() {
    return {
      showHistory: false,
      selectedReward: null,
      showIdentity: false,
      currentIdentity: null,
      selectStatus: '',
      campaignList: [],
      item: [
        {
          orderid: '4242'
        }
      ],
      filter: {
        search: '',
        name: '',
        role: '',
        status: '',
        dateFrom: '',
        dateTo: ''
      },
      pageNumber: 1,
      loading: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      campaignLoading: false,
      limit: 10,
      offset: 0,
      items: [],
      total: 0,
      pagetmp: 1,
      rewardIds: [],
      approveLoading: false,
      approveAllLoading: false,
      IsCheckAllOrder: false,
      exportloading: false,
      receiptStatus: 'ทั้งหมด'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onSelectReceiptStatus(option, id) {
      console.log(option, id)
      this.receiptStatus = option
      this.offset = 0
      this.getData()
    },
    async exportxlsx() {
      this.$store.dispatch('loading')
      this.exportloading = true
      let data = {
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid,
        // campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
        limit: 999,
        offset: 0,
        role:
          this.$store.state.privilege && this.$store.state.privilege.role
            ? this.$store.state.privilege.role
            : null,
        status:
          this.selectCampaign &&
          this.selectCampaign.type == 'lucky_draw' &&
          this.receiptStatus != 'ทั้งหมด'
            ? this.receiptStatus
            : null,
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null
      }

      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let response = await toaMegapaintApi.getExportReward(data)
          response = response.data
          let json = response.data

          let reward1 = []
          let reward2 = []

          json.forEach((e1) => {
            let data_count = {}
            e1.productdetails.forEach((e2) => {
              reward1.push({
                เลขที่ออเดอร์: e1.id,
                ชื่อลูกค้า: (e1.first_name || '') + ' ' + (e1.last_name || ''),
                สินค้าที่แลก: e2.name,
                จำนวนของรางวัลที่แลก: e2.quantity,
                รวมคะแนนที่แลก: e2.points,
                คะแนนคงเหลือ: e1.original_score ? e1.original_score - e1.total_points : '-',
                'Admin Approve': e1.adminid
              })
              if (!data_count[e2.name]) {
                data_count[e2.name] = e2.quantity
              } else {
                data_count[e2.name] = data_count[e2.name] + e2.quantity
              }
            })

            reward2.push({
              จำนวนคะแนนที่แลก: e1.original_score,
              รวมคะแนนที่แลก: e1.total_points,
              คะแนนคงเหลือ: e1.original_score ? e1.original_score - e1.total_points : '-',
              'Admin Approve': e1.adminid,
              ...data_count
            })
          })

          const wb = XLSX.utils.book_new()
          const dataWS = XLSX.utils.json_to_sheet(reward1)
          XLSX.utils.book_append_sheet(wb, dataWS, 'การแลกสินค้า')

          const dataWs2 = XLSX.utils.json_to_sheet(reward2)
          XLSX.utils.book_append_sheet(wb, dataWs2, 'การแลกสินค้า(2)')

          XLSX.writeFile(wb, 'exportedApproveReward' + '.xlsx')
        } catch (error) {
          console.error(error)
        } finally {
          this.exportloading = false
          this.$store.dispatch('loading')
        }
      } else {
        api.EXPORT_TOAECOUPONGetRewardRequest(data, (err, response) => {
          this.exportloading = false
          this.$store.dispatch('loading')
          if (response.responsecode == 200) {
            let json = response.data

            let reward1 = []
            let reward2 = []

            json.forEach((e1) => {
              let data_count = {}
              e1.productdetails.forEach((e2) => {
                reward1.push({
                  เลขที่ออเดอร์: e1.id,
                  ชื่อลูกค้า: (e1.first_name || '') + ' ' + (e1.last_name || ''),
                  สินค้าที่แลก: e2.name,
                  จำนวนของรางวัลที่แลก: e2.quantity,
                  รวมคะแนนที่แลก: e2.points,
                  คะแนนคงเหลือ: e1.original_score ? e1.original_score - e1.total_points : '-',
                  'Admin Approve': e1.adminid
                })
                if (!data_count[e2.name]) {
                  data_count[e2.name] = e2.quantity
                } else {
                  data_count[e2.name] = data_count[e2.name] + e2.quantity
                }
              })

              reward2.push({
                จำนวนคะแนนที่แลก: e1.original_score,
                รวมคะแนนที่แลก: e1.total_points,
                คะแนนคงเหลือ: e1.original_score ? e1.original_score - e1.total_points : '-',
                'Admin Approve': e1.adminid,
                ...data_count
              })
            })

            const wb = XLSX.utils.book_new()
            const dataWS = XLSX.utils.json_to_sheet(reward1)
            XLSX.utils.book_append_sheet(wb, dataWS, 'การแลกสินค้า')

            const dataWs2 = XLSX.utils.json_to_sheet(reward2)
            XLSX.utils.book_append_sheet(wb, dataWs2, 'การแลกสินค้า(2)')

            XLSX.writeFile(wb, 'exportedApproveReward' + '.xlsx')
          }
        })
      }
    },
    onChangeDate() {
      this.filter = {
        name: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.pageNumber = 1
      this.offset = 0
      this.getData(false, false, 'date')
    },
    getEnabledCampagin() {
      this.campaignLoading = true
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }

      api.TOAECOUPONgetAllCampaign(payload, (err, result) => {
        if (result.responsecode == 200) {
          this.campaignLoading = false
          this.campaignList =
            result.data.length > 0 ? result.data.filter((f) => f.type == 'collect') : []
          if (this.campaignList && this.campaignList.length > 0) {
            this.selectCampaign = this.campaignList[0]
            this.getData()
          }
        }
      })
    },
    getData() {
      return new Promise(async (resolve) => {
        this.loading = true

        let data = {
          pageid: this.selectedBot.pageid,
          page_id: this.selectedBot.pageid,
          campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
          start_date: this.selectedDate.start,
          end_date: this.selectedDate.end,
          limit: this.limit,
          offset: this.offset,
          role:
            this.$store.state.privilege && this.$store.state.privilege.role
              ? this.$store.state.privilege.role
              : null,
          status:
            this.selectCampaign &&
            this.selectCampaign.type == 'lucky_draw' &&
            this.receiptStatus != 'ทั้งหมด'
              ? this.receiptStatus
              : null
        }

        for (const key in this.filter) {
          if (this.filter[key]) {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }

        if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
          try {
            let response = await toaMegapaintApi.getReward(data)
            response = response.data
            this.items = response.data
            this.total = response.total
            resolve()
          } catch (error) {
            console.error(error)
          } finally {
            this.loading = false
          }
        } else {
          api.TOAECOUPONGetRewardRequest(data, (err, response) => {
            resolve()
            this.loading = false
            if (response.responsecode == 200) {
              this.items = response.data
              this.total = response.total
            }
          })
        }
      })
    },
    chooseCampaign(campaign) {
      this.selectCampaign = campaign
      this.offset = 0
      this.getData()
    },
    changePage(val) {
      if (this.pagetmp != val) {
        this.pagetmp = val
        this.offset = this.pageNumber * this.limit - this.limit
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.getData()
      }
    },
    async onApproveAll() {
      this.approveAllLoading = true
      this.$store.dispatch('loading')
      let payload = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.postApproveAllReward(payload)
          this.getData()
        } catch (error) {
          console.error(error)
        } finally {
          this.$store.dispatch('loading')
          this.approveAllLoading = false
          this.rewardIds = []
        }
      } else {
        api.TOAECOUPONApproveAllRewardRequest(payload, (err, result) => {
          this.$store.dispatch('loading')
          this.approveAllLoading = false
          this.rewardIds = []
          if (result.responsecode == 200) {
            this.getData()
          }
        })
      }
    },
    async onApprove() {
      if (this.rewardIds.length == 0) {
        return
      }

      this.$store.dispatch('loading')

      this.approveLoading = true
      let payload = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        rewardIds: this.rewardIds,
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.postApproveReward(payload)
          this.getData()
        } catch (error) {
          console.error(error)
        } finally {
          this.approveLoading = false
          this.$store.commit('CLEAR_LOADING')
          this.rewardIds = []
        }
      } else {
        api.TOAECOUPONApproveRewardRequest(payload, (err, result) => {
          this.approveLoading = false
          this.$store.commit('CLEAR_LOADING')
          this.rewardIds = []
          if (result.responsecode == 200) {
            this.getData()
          }
        })
      }
    },
    chooseOrder(item, value) {
      const index = this.rewardIds.find((f) => f.id == item.id)
      if (index != -1) {
        if (value) {
          this.rewardIds.push(item.id)
        } else {
          this.rewardIds.splice(index, 1)
        }
      } else {
        this.rewardIds.push(item.id)
      }
    },
    onApproveAllInCurrentPage(value) {
      if (value) {
        this.rewardIds = this.items.map((m) => m.id)
        this.IsCheckAllOrder = true
      } else {
        this.rewardIds = []
        this.IsCheckAllOrder = false
      }
    },
    handleSearch() {
      this.pageNumber = 1
      this.offset = 0
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
.isprimay {
  background-color: #ff706b !important;
  color: white !important;
}
.text-gray {
  color: #969595;
}
.text-cus {
  color: #ff706b !important;
}
.card-outline {
  border: 1px solid #ff706b;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Approvereward.vue